import React, { Component } from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';

class Goal extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                <div className="goal">
                    <div className="goal__inner">
                        <ScrollAnimation
                            animateIn="zoomIn"
                            offset={0}
                            animateOnce={true}
                            duration={1.2}
                        >
                            <img
                                className="goal__img"
                                src="/images/pic/bonum/goal.png"
                                alt="goal"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                        <div className="goal__wrapper">
                            <CommonTitle className="goal__title">Цель</CommonTitle>
                            <CommonSmallText className="goal__text">
                                Увеличение продаж в новых сегментах: зерновозы
                                и&nbsp;сельхозтехника, тентованные полуприцепы, а также продвижение
                                бренда и повышение его узнаваемости на российском рынке и в странах
                                СНГ.
                            </CommonSmallText>
                        </div>
                    </div>
                </div>
            </ScrollAnimation>
        );
    }
}

export default Goal;
